@if (mapConfig) {
  <div class="map-layer-controls">
    <div class="layer-meny-button">
      <i class="icon fas fa-layer-group"></i>
    </div>
    <div class="layer-meny-menu">
      <div class="menu-header">
        <div class="label-tiny" translate>Map layers</div>
      </div>
      <div class="menu-content">
        <mat-slide-toggle [(ngModel)]="mapConfig.showTrafficLayer"
          (change)="updateMapConfig()"
          [disabled]="isTrafficDisabled">
          <div class="toggle-item">
            <div class="text-x-small" translate>Traffic congestion</div>
          </div>
        </mat-slide-toggle>
        <mat-slide-toggle [(ngModel)]="mapConfig.showStopsNetwork"
          (change)="updateMapConfig()">
          <div class="toggle-item">
            <div class="text-x-small" translate>Stops</div>
          </div>
        </mat-slide-toggle>
        <mat-slide-toggle [(ngModel)]="mapConfig.showRouteNetwork"
          (change)="updateMapConfig()">
          <div class="toggle-item">
            <div class="text-x-small" translate>Route network</div>
          </div>
        </mat-slide-toggle>
        <mat-slide-toggle [(ngModel)]="mapConfig.showCityLabels"
          (change)="updateMapConfig()">
          <div class="toggle-item">
            <div class="text-x-small" translate>City labels</div>
          </div>
        </mat-slide-toggle>
      </div>
    </div>
  </div>
}